import axios from "axios";
import { data } from "jquery";

class PostData {
  constructor() {
    this.result = [];
  }

  Registeration = (data, setError) => {
    const res = async () => {
      const resp = await axios
        .post("users/", {
          email: data.email,
          password: data.password,
          displayName: data.FullName,
          // phoneNumber: "+" + data.phone,
        })

        .catch(function (error) {

          if (error.response.data.message == `"email" must be a valid email`) {
            setError("Please enter a valid email");

          }
          else {
            setError(error.response.data.message);
          }

        });
      return resp;
    };
    return res();
  };

  SaveApiDStatus = (data) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/", {

          ApiDStatus: data

        })
        .catch(function (error) {
          console.log(error.response);
        });
      return resp;
    };
    return res();
  };

  MiniForm = (data) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/", {
          idType: data.Type.value,
          residentialStatus: data.Status.value,
          CNIC: data?.CNIC,
          firstName: data.FullName,
          issueDate: data.IssueDate,
          email: data.email,
          number: "0" + data.phone.slice(-10),
          IBAN: data.IBANnumber.iban,
          relationWithMobileNo: data.relationWithMobileNo.value,
          relativeCNIC: null,
          proofofRelationship: null,
        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  };


  FileAndImageUpload = (data) => {

    const res = async () => {



      if (data) {


        let send = data[0] || data
        console.log({ send })
        // const axiosInstanceRemote = axios.create({
        //   baseUrl: "103.31.81.9:8080/api/v1/"
        // })
        // console.log('data for file is =======================>>>', data)
        var bodyFormData = new FormData();
        bodyFormData.append('files', send);


        const resp = await axios
          .post("https://aof-multinet.nextventures.com.pk/api/v1/save-file/", bodyFormData

          ).then(function (response) {
            return response
          })
          .catch(function (response) {
            return response;

          });

        return resp

      }
    }


    return res()
  }

  Login = (email, password) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/authenticate", {
          email: email,
          password: password,

        })
        .catch(function (error) {
          // alert(error.response.data.message);

          return error;
        });
      return resp;
    };
    return res();
  }

  SendNewRegisterEmail = () => {
    let mail = localStorage.getItem("regemail")
    let ud = localStorage.getItem("reguid")

    let abc = JSON.parse(localStorage.getItem("email"))
    let def = localStorage.getItem("email")

    const res = async () => {
      const resp = await axios
        .post("users/email-send", {
          email: JSON.parse(localStorage.getItem("email")),
          uid: JSON.parse(localStorage.getItem("uid")),

        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  }

  SendDocuments = (obj) => {



    const res = async () => {
      const resp = await axios
        .post("documents", obj)
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  }


  SendEmail = () => {



    const res = async () => {
      const resp = await axios
        .post("users/email-send", {
          email: JSON.parse(localStorage.getItem("email")),
          uid: JSON.parse(localStorage.getItem("uid")),

        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  }

  ForgetPasswordEmail = (paramsEmail) => {

    const res = async () => {
      const resp = await axios
        .post("users/forget-password-email", {
          email: paramsEmail,

        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  }

  ResetPassword = (password, urlKey) => {

    const res = async () => {
      const resp = await axios
        .post("users/forget-password", {
          password: password,
          key: urlKey
        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  }
  MiniForm = (data) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/", {
          idType: data.Type.value,
          residentialStatus: data.Status.value,
          CNIC: data?.CNIC,
          firstName: data.FullName,
          issueDate: data.IssueDate,
          email: data.email,
          number: "0" + data.phone.slice(-10),
          IBAN: data.IBANnumber.iban,
          relationWithMobileNo: data.relationWithMobileNo.value,
          relativeCNIC: null,
          proofofRelationship: null,
        })
        .catch(function (error) {
          // alert(error.response.data.message);
          console.log(error.response);
        });
      return resp;
    };
    return res();
  };

  MainForm = (data, setError, status) => {

    const res = async () => {
      const resp = await axios
        .post("account-details/", {
          uid: JSON.parse(localStorage.getItem("user"))?.user_id,
          status: true,
          ACCOUNT_TYPE: data?.Type?.value,
          ACCOUNT_TYPE_KEY: data?.Type?.label,
          firstName: data?.firstName,
          lastName: data?.lastName,
          SALUTATION: data?.Salutations.value,
          SALUTATION_KEY: data?.Salutations?.label,
          PLACE_OF_BIRTH: data?.placeOfBirth,
          GENDER: data?.Gender,
          MARITAL_STATUS: data?.MaritalStatus,
          RELATIONSHIP: data?.Relation?.value,
          RELATIONSHIP_KEY: data?.Relation?.label,
          FATHER_HUSBAND_NAME: data?.RelativeName,
          DATE_OF_BIRTH: data?.BirthDay,
          NATIONALITY: data?.Citizenship?.value,
          NATIONALITY_KEY: data?.Citizenship?.label,
          residentialStatus: data?.Resident?.value,
          RESIDENT_KEY: data?.Resident?.label,
          PERMANENT_ADDRESS_1: data?.Apt,
          PERMANENT_ADDRESS_2: data?.street,
          PERMANENT_ADDRESS_3: data?.country?.iso3,
          COUNTRY1_KEY: data?.country?.label,
          PERMANENT_PROVINCE: data?.Provinces?.Province_code,
          PROVINCE_KEY: data?.Provinces?.label,
          PERMANENT_CITY_TOWN: data?.City.City_Code,
          MAILING_ADDRESS_1: data?.MailApt,
          MAILING_ADDRESS_2: data?.Mailstreet,
          MAILING_ADDRESS_3: data?.mailCountry?.value,
          COUNTRY_KEY: data?.mailCountry?.label,
          PROVINCE_STATE: data?.MailProvinces?.value,
          PROVINCE_STATE_KEY: data?.MailProvinces?.label,
          CITY_TOWN_VILLAGE: data?.MailCity,
          email: data?.email,
          relationWithMobileNo: data?.CellPhone,
          number: "03" + data?.Number.slice(-9),


          RELATIVE_NAME: data?.CellPhone == 2 ? data?.ProofRelationName : '',
          //Realitive Type
          relativeCNIC: data?.CellPhone == 2 ? data?.RelativeCNIC : '',
          RELATIVE_PROOF: '',
          // RELATIVE_PROOF: values.ProofRelationFileName,
          RELATIONSHIP: data?.CellPhone == 2 ? data?.proofRelation.value : '',
          RELATIONSHIP_KEY: data?.CellPhone == 2 ? data?.proofRelation.label : '',


          // RELATIVE_NAME: data?.ProofRelationName,
          //Realitive Type
          // relativeCNIC: data?.RelativeCNIC,
          // RELATIVE_PROOF: "",
          // RELATIVE_PROOF: data.ProofRelationFileName,

          idType: data?.IDType,
          CNIC: data?.CNIC,
          issueDate: data?.IssueDate,
          DATE_OF_EXPIRY: data?.ExpiryDate,
          //lifeTime Expiry
          IBAN: data?.IBAN?.iban,
          //Employment Status
          EMPLOYER_NAME: data?.CompName,
          OCCUPATION: data?.BussType?.value,
          OCCUPATION_KEY: data?.BussType?.label,
          JOB_TITLE: data?.JobTitle,
          Department: data?.Department,
          //Employer Apt
          EMPLOYER_ADDRESS: data?.EmployStreet,
          GROSS_ANNUAL_INCOME: data?.AnnualIncome?.value,
          GROSS_ANNUAL_INCOME_KEY: data?.AnnualIncome?.label,
          ZAKAT_STATUS: data?.Zakat?.value,
          ZAKAT_STATUS_KEY: data?.Zakat?.label,
          E_WALLET_PROVIDER: data.ewalletprovider.value,
          E_WALLET_PROVIDER_KEY: data?.ewalletprovider?.label,
          OTHER_E_WALLET_PROVIDER: data.otherewalletprovider.value,
          E_WALLET_NUMBER: data.ewalletnumber.value,
          Remittance: data?.BasisOfRemittance?.value,
          RemittanceKey: data?.BasisOfRemittance.label,
          CNIC_FRONT: "",
          CNIC_BACK: "",
          // CNIC_FRONT: data.CNICFileFrontName,
          // CNIC_BACK: data.CNICFileBackName,
          ADD_PROOF: "",
          // ADD_PROOF: data.sendSalerySlipName,
          TERMS_CONDITIONS: "", //what to send in this?

          // Not found for following

          COUNTRY: "",
          proofofRelationship: "",
          Client_Code: "",
          OTHERPROVINCE_STATE: "",
          OTHERCITY_TOWN_VILLAGE: "",
          TELEPHONE_OFFICE: "",
          TELEPHONE_RESIDENCE: "",
          FAX: "",
          PERMANENT_COUNTRY: "",
          PERMANENT_OTHERPROVINCE: "",
          PERMANENT_OTHERCITY_TOWN: "",
          PERMANENT_TELEPHONE_OFFICE: "",
          PERMANENT_TELEPHONE_RESIDENCE: "",
          PERMANENT_CELL_NO: "",
          PERMANENT_EMAIL: "",
          PERMANENT_FAX: "",
          SOURCE_OF_INCOME: "",
          OTHER_OCCUPATION: "",
          BANK_NAME: "",
          EMP_ADD_PROOF: "",
          SIGNATURE_PROOF: "",
          TERMS_CONDITIONS: "",
          ProofofIBAN: "",
          ZAKAAT_DECLARATION: "",
          Remittance: "",

          // These are to be send empty for Now
          Salutation_ATR: "",
          CLIENT_NAME_ATR: "",
          IDENTIFICATION_ATR: "",
          CNIC_ATR: "",
          CNIC_EXPIRY_DATE_ATR: "",
          CNIC_LIFETIME_ATR: "",
          Mobile_ATR: "",
          Email_ATR: "",
          Mailing_ADDRESS_ATR_1: "",
          Mailing_ADDRESS_ATR_2: "",
          Mailing_ADDRESS_ATR_3: "",
          Mailing_Country_ATR: "",
          Mailing_Province_ATR: "",
          Other_Mailing_Prov_ATR: "",
          Mailing_CITY_ATR: "",
          Other_Mailing_CITY_ATR: "",
          Landline_ATR: "",
          FAX_ATR: "",
          NAME_NMN: "",
          IDENTIFICATION_NMN: "",
          RELATIONSHIP_NMN: "",
          CNIC_NMN: "",
          CNIC_EXPIRY_DATE_NMN: "",
          CNIC_LIFETIME_NMN: "",
        })
        .catch(function (error) {
          console.log(error.response);
          setError(error.response.data.message);
        });
      this.result = resp;
      return resp;
    };
    return res();
  };

  SaveAndExit = (data, setError, status) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/", {
          uid: JSON.parse(localStorage.getItem("user"))?.user_id,
          status: status,
          ACCOUNT_TYPE: data.Type.value,
          ACCOUNT_TYPE_KEY: data?.Type?.label,
          firstName: data.firstName,
          lastName: data?.lastName,
          SALUTATION: data?.Salutations.value,
          SALUTATION_KEY: data?.Salutations?.label,
          PLACE_OF_BIRTH: data?.placeOfBirth,
          GENDER: data.Gender,
          MARITAL_STATUS: data.MaritalStatus,

          RELATIONSHIP1: data?.Relation?.value,
          RELATIONSHIP1_KEY: data?.Relation?.label,
          FATHER_HUSBAND_NAME: data.RelativeName,
          DATE_OF_BIRTH: data.BirthDay,
          NATIONALITY: data.Citizenship.value,
          residentialStatus: data.Resident.value,
          PERMANENT_ADDRESS_1: data.Apt,
          PERMANENT_ADDRESS_2: data.street,
          PERMANENT_ADDRESS_3: data.country.iso3,
          PERMANENT_PROVINCE: data.Provinces.Province_code,
          PERMANENT_CITY_TOWN: data.City.City_Code,
          MAILING_ADDRESS_1: data.MailApt,
          MAILING_ADDRESS_2: data.Mailstreet,
          MAILING_ADDRESS_3: data.mailCountry.value,
          PROVINCE_STATE: data.MailProvinces.value,
          CITY_TOWN_VILLAGE: data.MailCity,
          email: data.email,
          relationWithMobileNo: data.CellPhone,
          number: "0" + data.Number.slice(-10),


          RELATIVE_NAME: data?.CellPhone == 2 ? data?.ProofRelationName : '',
          //Realitive Type
          relativeCNIC: data?.CellPhone == 2 ? data?.RelativeCNIC : '',
          RELATIVE_PROOF: '',
          RELATIONSHIP: data?.CellPhone == 2 ? data?.proofRelation.value : '',
          RELATIONSHIP_KEY: data?.CellPhone == 2 ? data?.proofRelation.label : '',


          // RELATIVE_NAME: data.ProofRelationName,
          // relativeCNIC: data.RelativeCNIC,
          // RELATIVE_PROOF: "",
          idType: data.IDType,
          CNIC: data.CNIC,
          issueDate: data.IssueDate,
          DATE_OF_EXPIRY: data.ExpiryDate,
          //lifeTime Expiry
          IBAN: data.IBAN.iban,
          //Employment Status
          EMPLOYER_NAME: data.CompName,
          OCCUPATION: data.BussType.value,
          JOB_TITLE: data.JobTitle,
          Department: data.Department,
          //Employer Apt
          EMPLOYER_ADDRESS: data.EmployStreet,
          GROSS_ANNUAL_INCOME: data.AnnualIncome.value,
          ZAKAT_STATUS: data.Zakat.value,
          ZAKAT_STATUS_KEY: data?.Zakat?.label,
          E_WALLET_PROVIDER: data.ewalletprovider.value,
          E_WALLET_PROVIDER_KEY: data?.ewalletprovider?.label,
          OTHER_E_WALLET_PROVIDER: data.otherewalletprovider.value,
          E_WALLET_NUMBER: data.ewalletnumber.value,
          Remittance: data?.BasisOfRemittance?.value,
          RemittanceKey: data?.BasisOfRemittance.label,
          CNIC_FRONT: "",
          CNIC_BACK: "",
          ADD_PROOF: "",
          TERMS_CONDITIONS: "", //what to send in this?

          // Not found for following

          COUNTRY: "",
          proofofRelationship: "",
          Client_Code: "",
          OTHERPROVINCE_STATE: "",
          OTHERCITY_TOWN_VILLAGE: "",
          TELEPHONE_OFFICE: "",
          TELEPHONE_RESIDENCE: "",
          FAX: "",
          PERMANENT_COUNTRY: "",
          PERMANENT_OTHERPROVINCE: "",
          PERMANENT_OTHERCITY_TOWN: "",
          PERMANENT_TELEPHONE_OFFICE: "",
          PERMANENT_TELEPHONE_RESIDENCE: "",
          PERMANENT_CELL_NO: "",
          PERMANENT_EMAIL: "",
          PERMANENT_FAX: "",
          SOURCE_OF_INCOME: "",
          OTHER_OCCUPATION: "",
          BANK_NAME: "",
          EMP_ADD_PROOF: "",
          SIGNATURE_PROOF: "",
          TERMS_CONDITIONS: "",
          ProofofIBAN: "",
          ZAKAAT_DECLARATION: "",
          Remittance: "",

          // These are to be send empty for Now
          Salutation_ATR: "",
          CLIENT_NAME_ATR: "",
          IDENTIFICATION_ATR: "",
          CNIC_ATR: "",
          CNIC_EXPIRY_DATE_ATR: "",
          CNIC_LIFETIME_ATR: "",
          Mobile_ATR: "",
          Email_ATR: "",
          Mailing_ADDRESS_ATR_1: "",
          Mailing_ADDRESS_ATR_2: "",
          Mailing_ADDRESS_ATR_3: "",
          Mailing_Country_ATR: "",
          Mailing_Province_ATR: "",
          Other_Mailing_Prov_ATR: "",
          Mailing_CITY_ATR: "",
          Other_Mailing_CITY_ATR: "",
          Landline_ATR: "",
          FAX_ATR: "",
          NAME_NMN: "",
          IDENTIFICATION_NMN: "",
          RELATIONSHIP_NMN: "",
          CNIC_NMN: "",
          CNIC_EXPIRY_DATE_NMN: "",
          CNIC_LIFETIME_NMN: "",
        })
        .catch(function (error) {
          console.log(error.response);
          setError(error.response.data.message);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };

  VerifyOtp = (data) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/otp-verify", {
          otp: data,
        })
        .catch(function (error) {
          console.log(error.response);
        });
      this.result = resp;

      return resp;
    };

    return res();
  };

  ResendOtp = (data) => {
    const res = async () => {
      const resp = await axios
        .post("account-details/resend-otp", {
          otp: data,
        })
        .catch(function (error) {
          console.log(error.response);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };

  Return() {
    return this.result;
  }
}
export default new PostData();
